import { mapActionsFromConfigurations } from '../../helpers/action';
import { configurations } from './configurations';
import { apiAction as deleteKey } from './configurations/deleteKey';
import { apiAction as generateBusinessKey } from './configurations/generateBusinessKey';
import { apiAction as generateKey } from './configurations/generateKey';
import { apiAction as getBusinessKeys } from './configurations/getBusinessKeys';
import { apiAction as getKeys } from './configurations/getKeys';

export const apiActions = {
  apiKey: {
    getKeys,
    getBusinessKeys,
    generateKey,
    generateBusinessKey,
    deleteKey
  }
}

const actions = mapActionsFromConfigurations('apiKey')(configurations);

export { API_ENDPOINT } from './configurations/endpoints';

export default actions;



// WEBPACK FOOTER //
// ./src/state/modules/api-key/actions.js